import { environment } from "src/environments/environment";

export const API_BASE_URL=environment.HOST_URL;
export const OAUTH2_URL=API_BASE_URL+ 'oauth2/authorization/google';
export const REDIRECT_URL=`?redirect_uri=${environment.BASE_URL}auth/login`;
export const AUTH_URL=OAUTH2_URL + REDIRECT_URL;